export const LobbyHomePages = {
  LiveCasinoHome: "livecasino-home",
  CasinoLobbyHome: "casino-home",
  TvgamesHome: "tvgames-home",
  VirtualSportHome: "virtualsport-home",
  FastGamesHome: "fastgames-home",
};

export const LobbyHomeTypeEnum = {
  "livecasino-home": 1,
  "casino-home": 2,
  "tvgames-home": 3,
  "virtualsport-home": 4,
  "fastgames-home": 5,
};

export const LobbyToHome = {
  "livecasino": "livecasino-home",
  "casino-lobby": "casino-home",
  "tvgames-lobby": "tvgames-home",
  "virtualsport-lobby": "virtualsport-home",
  "fastgames-lobby": "fastgames-home",
};

export const HomeToLobby = {
  "livecasino-home": "livecasino",
  "casino-home": "casino-lobby",
  "tvgames-home": "tvgames-lobby",
  "virtualsport-home": "virtualsport-lobby",
  "fastgames-home": "fastgames-lobby",
};

export const WidgetContentType = {
  GameWidget: 1,
  SystemGroupGameWidget: 2,
  ProviderWidget: 3,
  ActionLinkWidgets: 4,
  TopWinWidget: 5,
  TopXWidget: 6,
  RandomGameWidget: 7,
  ProviderWithGames: 8,
  SingleGameWidget: 9,
  JackpotWidget: 10,
  ImageWidget: 11,
  CollectionWidget: 12,
  BannerWidget: 13,
  StoryWidget: 14,
  MobileSearch: 15
};

export const gameGridType = {
  Standart: 1,
  Advanced: 2,
  Vertical: 3,
  Horizontal: 4,
};

export const GridClassName = {
  [gameGridType.Standart]: "standard-games",
  [gameGridType.Vertical]: "vertical-games",
  [gameGridType.Horizontal]: "horizontal-games",
  [gameGridType.Advanced]: "advanced-games"
}
